const ITEMS = [
  "Cased-Hole Logging",
  "Perforating",
  "Production Logging",
  "Pipe Recovery",
  "Well Integrity",
  "Offshore Operations",
  "Electrical Sales & Supply",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      className="border-y border-white/10 bg-secondary/40 overflow-hidden py-6 md:py-8"
      aria-hidden="true"
      data-testid="marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee-slow">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl text-foreground/80 px-8">
              {item}
            </span>
            <span className="text-primary text-3xl md:text-5xl">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
}
